import FJLocalStore from '../../../store/FJLocalStore';
import FJToolTip from '../FJToolTip/FJToolTip';
import { useMemo } from 'react';
import DeleteIcon from '../../../assets/svg/delete.svg?react';
import EditIcon from '../../../assets/svg/edit-1.svg?react';
import ShareSmallIcon from '../../../assets/svg/share-small.svg?react';
import ComparisonIcon from '../../../assets/svg/comparison.svg?react';
import FacebookIcon from '../../../assets/svg/facebook-social.svg?react';
import TwitterIcon from '../../../assets/svg/twitter-social.svg?react';
// import TumblrIcon from '../../../assets/svg/tumblr-social.svg?react';
import ShareIcon from '../../../assets/svg/share.svg?react';
import FJDropDown from '../FJDropDown/FJDropDown';
import styles from './FJImageItemIconBox.module.less';
import classNames from 'classnames';
import FJMessageStore from '../../../store/FJMessageStore';
import FJUtil from '../../../util/FJUtil';
import { useCallback } from 'react';
import FJConstant from '../../../constants/FJConstant';

const shareList = [
    { type: FJConstant.FACEBOOK, icon: <FacebookIcon /> },
    { type: FJConstant.TWITTER, icon: <TwitterIcon /> },
    // { type: FJConstant.TUMBLR, icon: <TumblrIcon /> },
    { type: FJConstant.COPY_LINK, icon: <ShareIcon /> },
];

const FJImageItemIconBox = props => {
    const {
        isShowDeleteIcon,
        isShowComparison,

        imageLoadingError = false,
        disabledComparison = false,
        isComparisonActive = false,
        isShowEditIcon = false,

        onDelete,
        shareToSociety,
        changeComparison,
        onEdit,
        reLoadImage,
    } = props;

    const _onMouseUp = useCallback(() => {
        changeComparison && changeComparison(false);
        FJUtil.removeEvent(window, 'mouseup', _onMouseUp);
    }, [changeComparison]);

    const _onMouseDown = useCallback(() => {
        if (imageLoadingError) {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-please-try-again'), 'error');
            reLoadImage && reLoadImage();
            return;
        }
        if (disabledComparison) return;

        changeComparison && changeComparison(true);
        FJUtil.addEvent(window, 'mouseup', _onMouseUp);

        return () => {
            FJUtil.removeEvent(window, 'mouseup', _onMouseUp);
        };
    }, [imageLoadingError, reLoadImage, disabledComparison, changeComparison, _onMouseUp]);

    const _shareOverlay = useMemo(() => {
        return (
            <div className={styles.share_box}>
                <div className={styles.share_title}>{FJLocalStore._('share')}</div>
                <div className={styles.share_content}>
                    {shareList.map(item => (
                        <div
                            key={item.type}
                            className={styles.share_img_box}
                            onClick={() => {
                                shareToSociety && shareToSociety(item.type);
                            }}
                        >
                            {item.icon}
                        </div>
                    ))}
                </div>
            </div>
        );
    }, [shareToSociety]);

    return (
        <div className={styles.box}>
            {isShowDeleteIcon && (
                <FJToolTip title={'delete'}>
                    <div className={styles.hover_box} onClick={onDelete}>
                        <DeleteIcon />
                    </div>
                </FJToolTip>
            )}

            <FJDropDown
                zIndex={9999}
                placement='bottomCenter'
                overlay={_shareOverlay}
                overlayClassName={styles.overlay}
                trigger='click'
            >
                <FJToolTip title={'share'}>
                    <div className={styles.hover_box}>
                        <ShareSmallIcon />
                    </div>
                </FJToolTip>
            </FJDropDown>

            {isShowComparison && (
                <FJToolTip title={'compare'}>
                    <div
                        className={classNames(styles.hover_box, isComparisonActive ? styles.active : '')}
                        onMouseDown={_onMouseDown}
                    >
                        <ComparisonIcon />
                    </div>
                </FJToolTip>
            )}

            {isShowEditIcon && (
                <FJToolTip title={'upload'}>
                    <div className={styles.hover_box} onClick={onEdit}>
                        <EditIcon />
                    </div>
                </FJToolTip>
            )}
        </div>
    );
};
export default FJImageItemIconBox;
